const BackMenu = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <path
        d="M12.0566 5.37207L7.59913 9.82958L12.0566 14.2871"
        stroke="#1E1E1E"
        strokeWidth="1.11438"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default BackMenu;
